import Region from '@/creditflowresearch/domain/Region/Region';
import { RegionType } from '@/creditflowresearch/domain/Region/RegionType';
import { USOA_REGION_ID, USOA_ABBREVIATION } from '@/creditflowresearch/domain/Region/constants';
import { US_MARKET_ID } from '@/creditflowresearch/domain/Market/constants';

class UsoaRegion extends Region {
  static readonly REGION_ID: string = USOA_REGION_ID;

  static readonly ABBREVIATION: string = USOA_ABBREVIATION;

  static readonly TYPE: RegionType = RegionType.USOA;

  protected getMarketIdForRegion(): string | null {
    return US_MARKET_ID;
  }
}

export default UsoaRegion;
